import type { BuildingDataWidgetSections } from "../../../types/buildings-sections/building-data-widget";

export const buildingDataWidget: BuildingDataWidgetSections = {
  pageSubtitle: "Vaata, kinnita ja muuda selle hoone andmevälju",
  buildingDataHistory: "Hoone andmete ajalugu",
  backToHistory: "Tagasi hoone andmete ajalukku",
  closeHistory: "Sulge hoone andmete ajalugu",
  resizeHistoryPanel: "Muuda hoone andmete ajaloo paneeli suurust",
  searchFields: "Otsi välju…",
  loading: "Laadimine…",
  dataLoadError: "Hoone andmete laadimine ebaõnnestus",
  retryData: "Proovi uuesti",
  noFieldsMatch: 'Ühtegi välja ei vasta otsingule „{query}"',
  noFieldsYet: "Väljasid pole veel kuvada",
  updatedAgo: "Uuendatud · {time}",
  updatedNever: "Uuendatud · —",
  pendingGroupHint: "Selles grupis on kinnitamata leide",
  addValue: "Lisa väärtus",
  optionsCount: "{count} valikut",
  editedBy: "Muutis",
  confirmedBy: "Kinnitas",
  unknownUser: "tundmatu",
  confirmValue: "Kinnita",
  confirmThisValue: "Kinnita see väärtus",
  rejectEdit: "Lükka tagasi / muuda",
  dismiss: "Sulge",
  typeNewValue: "Sisesta uus väärtus…",
  saveTypedValue: "Salvesta sisestatud väärtus",
  editValue: "Muuda",
  saveError: "Salvestamine ebaõnnestus",
  missingUserProfile: "Kasutajaprofiil puudub",
  cannotOpenDocument: "Dokumenti ei saa avada",
  selectAnOption: "Vali väärtus",
  selectMultiple: "Vali üks või mitu",
  noOptions: "Valikuid pole",
  extremeValueTitle: "See väärtus tundub ebatavaline",
  extremeValueBody:
    "Sisestatud väärtus tundub selle atribuudi jaoks ebatavaline. Kas soovid selle ikkagi salvestada?",
  extremeValueSaveAnyway: "Salvesta siiski",
  extremeValueEdit: "Muuda",
  done: "Valmis",
  cancel: "Tühista",
  clearValue: "Tühjenda väärtus",
  filterAll: "Kõik",
  filterEmpty: "Tühjad",
  filterPending: "Ootel",
  noFieldsForFilter: "Sellele filtrile ei vasta ühtegi välja",
  acceptNewValue: "Aktsepteeri uus väärtus",
  keepCurrentValue: "Säilita praegune väärtus",
  previousValueLabel: "Eelmine",
  proposedValueLabel: "Uus leid",
  currentValueLabel: "Praegune",
  viewHistory: "Vaata väärtuse ajalugu",
  valueHistory: "Väärtuse ajalugu",
  supportingSources: "Tugiallikad",
  noHistory: "Ajalugu pole veel salvestatud",
  loadingHistory: "Ajaloo laadimine…",
  historyLoadError: "Ajaloo laadimine ebaõnnestus",
  retryHistory: "Proovi uuesti",
  sourceEhr: "EHR register",
  sourceExtractor: "Dokumentidest tuvastatud",
  sourceIfc: "BIM mudel",
  franklinFindings: "Franklini leiud",
  statusConfirmed: "Kinnitatud",
  statusNeedsReview: "Vajab ülevaatamist",
  statusNewFinding: "Uus leid",
  statusMissing: "Puudub",
  actionSaved: "Hoone andmed uuendatud",
  actionUndone: "Muudatus võeti tagasi",
  undoAction: "Võta tagasi",
  rejectValue: "Lükka väärtus tagasi",
  showMore: "Näita rohkem",
  showLess: "Näita vähem",
  confirmAll: "Kinnita kõik {count}",
  sections: "Jaotised",
  collapseSections: "Ahenda jaotised",
  expandSections: "Laienda jaotised",
  allFields: "Kõik väljad",
  closeInspector: "Sulge inspektor",
  resizeInspector: "Muuda paneeli laiust",
  confidence: "Kindlus",
  confidenceHigh: "Kõrge",
  confidenceMedium: "Keskmine",
  confidenceLow: "Madal",
  completionPercent: "{percent}% valmis",
  valueLabel: "Väärtus",
  save: "Salvesta",
  sourceEvidence: "Allikaviide",
  otherMentions: "Muud mainimised ({count})",
  pageLabel: "Lehekülg",
  loadingEvidence: "Allikakatkendi laadimine…",
  evidenceLoadError: "Allikakatkendi laadimine ebaõnnestus.",
  retryEvidence: "Proovi uuesti",
  history: "Ajalugu",
  reject: "Lükka tagasi",
  accept: "Kinnita",
  reviewQueue: "Hoone andmete ülevaatusjärjekord",
  reviewProgress: "Ülevaatus {current}/{total}",
  exitReview: "Lõpeta ülevaatus",
  valueAccepted: "Väärtus kinnitatud",
  valueRejected: "Väärtus lükati tagasi ja märgiti puuduvaks",
  proposedValue: "Pakutud väärtus",
  alternateCandidates: "Teised väärtused",
  noAlternateCandidates: "Alternatiivseid väärtusi ei leitud",
  previous: "Eelmine",
  skip: "Jäta vahele",
  reviewFields: "Vaata üle {count} välja",
  seeHistory: "Vaata ajalugu",
  sectionConfirmed: "Kinnitatud {count} väärtust",
  sectionConfirmPartial:
    "Kinnitatud {confirmed}/{total} väärtust. Ebaõnnestunud väärtusi ei muudetud.",
  sectionConfirmValidationBlocked:
    "Kinnitatud {confirmed} väärtust. {invalid} ebatavalist väärtust jäid eraldi ülevaatamiseks.",
};
